import { makeStyles } from "@material-ui/core/styles";
import GeoTagMap from "../../../photo/components/GeoTagMap";
import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { LatLong } from "../../../../types/GPSLocation";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    flexFlow: "column",
    padding: "5%"
  },
  text: {
    marginBottom: `${theme.spacing(2)}px`
  },
  button: {
    marginTop: `${theme.spacing(2)}px`
  }
}));

type Props = {
  currentLocation: LatLong;
  onSubmit: (location: LatLong) => void;
};

const ReadingGeoTag = ({ currentLocation, onSubmit }: Props) => {
  const classes = useStyles();

  const [location, setLocation] = useState(currentLocation);

  return (
    <>
      <div className={classes.text}>
        Please select the location <strong>where you took the reading</strong>:
      </div>
      <GeoTagMap onLocationUpdate={setLocation} />
      <Button
        className={classes.button}
        onClick={() => onSubmit(location)}
        color="primary"
        variant="contained"
        size="large"
        disableElevation
      >
        Continue
      </Button>
    </>
  );
};

export default ReadingGeoTag;
